<list-view *ngIf="listeAlertes" [liste]="listeAlertes"></list-view>

<floating-button [listeActions]="listeActions"></floating-button>